import React from 'react';
import { useTranslation } from 'react-i18next';
import { DotsVerticalIcon as MenuContractIcon } from '@heroicons/react/outline';

import { ReactComponent as MenuIcon } from 'assets/menu.svg';
import { useSettings } from 'contexts';

type Props = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  styleSlug?: string;
};

const MenuButton: React.FC<Props> = ({ styleSlug = 'eth', className, ...buttonProps }) => {
  const { t } = useTranslation();
  const { isSidebarExpanded } = useSettings();
  return (
    <div
      className={`rounded-10 h-full bg-${styleSlug}-light bg-gradient-to-l dark:from-${styleSlug}-light dark:to-${styleSlug}-primary ${
        className || ''
      }`}
      style={{ padding: 2 }}
    >
      <button className="rounded-8 px-2 pt-1.5 pb-2 bg-white dark:bg-gray-111" {...buttonProps}>
        {isSidebarExpanded ? (
          <MenuContractIcon
            className={`w-6 h-6 text-${styleSlug}-primary dark:text-${styleSlug}-light`}
          />
        ) : (
          <MenuIcon
            className={`w-6 h-6 text-${styleSlug}-primary dark:text-${styleSlug}-light stroke-current`}
            title={t('header.toggle_menu')}
          />
        )}
      </button>
    </div>
  );
};

export default MenuButton;
